import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { RouteConstants } from 'app/routes';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { generatePath, useHistory } from 'react-router-dom';
import useLoadPolygons from 'utils/hooks/useLoadPolygons';
import { useResponsiveQuery } from 'utils/responsiveQuery/useResponsiveQuery';
import { useLoadAllRoutes } from '../../../../../../utils/hooks/useGetAllRoutes';
import moment from 'moment';
import { formatRouteDateFilter } from 'utils/helpers';
import { AllRoutesFiltersType } from 'app/containers/Field/slice/types';

export const useFieldListPage = () => {
  const history = useHistory();

  const { t } = useTranslation();

  const { mobileOrTablet } = useResponsiveQuery();

  const envId = useSelector(selectSelectedEnvId);

  const [searchQuery, setSearchQuery] = useState('');

  // Load data
  useLoadPolygons();
  const { allRoutesFilters, setAllRoutesFilters } = useLoadAllRoutes();

  const allRoutesDateFilters: [moment.Moment | null, moment.Moment | null] = [
    allRoutesFilters.startDate ? moment(allRoutesFilters.startDate) : null,
    allRoutesFilters.endDate ? moment(allRoutesFilters.endDate) : null,
  ];

  const onAllRoutesDateFilterChange = (
    values: [moment.Moment | null, moment.Moment | null] | null,
    dateStringValues: [string, string],
  ) => {
    const newFilters: AllRoutesFiltersType = {};

    if (values) {
      newFilters.startDate = formatRouteDateFilter({
        momentValue: values[0],
        isStartOfDay: true,
      });
      newFilters.endDate = formatRouteDateFilter({
        momentValue: values[1],
        isStartOfDay: true,
      });
    }
    console.log('newFilters:', newFilters);

    setAllRoutesFilters(newFilters);
  };

  const openAddField = () => {
    history.push(
      generatePath(RouteConstants.field.addField, {
        envId: Number(envId),
      }),
    );
  };

  const responsivePadding = mobileOrTablet ? 6 : 12;

  return {
    responsivePadding,
    openAddField,
    envId,
    t,
    mobileOrTablet,
    searchQuery,
    setSearchQuery,
    allRoutesDateFilters,
    onAllRoutesDateFilterChange,
  };
};
